import { HttpContextToken } from '@angular/common/http';

export const CUSTOM_ERROR_HANDLING = new HttpContextToken<string>(
  () => 'default',
);
